import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Box } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';

import { ModalFormSection } from 'components/common/modals';
import { ButtonV2 } from 'components/common/ui';
import { FieldV2 } from 'components/common/form-controls';
import { ModalFooter } from 'components/common/modals/ModalV2';
import validationSchema from './validationSchema';

import styles from './servicePointContactModalForm.style';

const ROLES = [
  {
    text: 'Technician',
    value: 'Technician',
  },
  {
    text: 'Call Center Agent',
    value: 'CallCenterAgent',
  },
  {
    text: 'Accounting',
    value: 'Accounting',
  },
  {
    text: 'Legal',
    value: 'Legal',
  },
  {
    text: 'Sales',
    value: 'Sales',
  },
  {
    text: 'Claims/Insurance Agent',
    value: 'ClaimsInsuranceAgent',
  },
  {
    text: 'Owner',
    value: 'Owner',
  },
];

const DEFAULT_VALUES = {
  fullName: '',
  role: '',
  phoneNumberMain: '',
  phoneNumberSecondary: '',
  email: '',
  isDismissed: false,
  isPrimary: false,
};

const ServicePointContactModalForm = ({
  isLoading,
  defaultValues = DEFAULT_VALUES,
  onCancel,
  onSubmit,
}) => {
  const resolver = yupResolver(validationSchema);

  const methods = useForm({ resolver });

  useEffect(() => {
    methods.reset(defaultValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);

  return (
    <FormProvider {...methods}>
      <form
        id="service-point-contact-form"
        onSubmit={methods.handleSubmit(onSubmit)}
      >
        <ModalFormSection>
          <Box sx={styles.row}>
            <FieldV2
              isRequired
              label="Full Name"
              type="text"
              control={methods.control}
              name="fullName"
            />
            {defaultValues?.id && (
              <FieldV2
                label="Primary Contact person"
                type="checkbox"
                control={methods.control}
                name="isPrimary"
              />
            )}
          </Box>
          <Box sx={styles.row}>
            <FieldV2
              isRequired
              label="Role"
              type="dropdown"
              control={methods.control}
              name="role"
              options={ROLES}
            />

            <FieldV2
              isRequired
              label="Phone #"
              type="text"
              control={methods.control}
              name="phoneNumberMain"
            />
          </Box>
          <Box sx={styles.row}>
            <FieldV2
              label="Phone # 2"
              type="text"
              control={methods.control}
              name="phoneNumberSecondary"
            />
            <FieldV2
              isRequired
              label="E-mail"
              type="text"
              control={methods.control}
              name="email"
            />
          </Box>
          {defaultValues?.id && (
            <Box sx={styles.row}>
              <FieldV2
                label="Dismissed"
                type="checkbox"
                control={methods.control}
                name="isDismissed"
              />
            </Box>
          )}
        </ModalFormSection>

        <ModalFooter>
          <ButtonV2 type="button" variant="outlined" onClick={onCancel}>
            Cancel
          </ButtonV2>
          <ButtonV2
            form="service-point-contact-form"
            type="submit"
            disabled={
              isLoading ||
              methods.formState.isSubmitting ||
              !methods.formState.isDirty
            }
          >
            Save
          </ButtonV2>
        </ModalFooter>
      </form>
    </FormProvider>
  );
};

export default ServicePointContactModalForm;
